import React, { useMemo, useEffect } from "react";
import { version } from "../clients/account-portal/package.json.js";
import { config } from "../frontends/account-portal-legacy/package.json.js";
import { mfServer } from "@account/configs";
import { GlModal } from "@adl/component-modal";
import { createReactClient } from "@astro-mf/client/react";
import { instana } from "@crystal/analytics";
import { MicrofrontendClient, useDevice } from "@crystal/core";
import { FeatureFlagsProvider, useFeatureFlags } from "@crystal/feature-flags";
import { AccountPortalAuthN } from "../ap2/client/AccountPortalAuthN.js";
import { FormView, RegistrationFlow } from "../config/application-flow.js";
import { saveInvitationCodeValue } from "../config/external-parameters.js";
import { isInlinePreset, getPreset, isModalViewForbiddenPath } from "../config/preset-utils.js";
import { useRuntimeInfo } from "../integration/hooks.js";
import { closeAccountPortal, updateRuntimeInfo } from "../integration/state-triggers.js";
import { getRuntimeInfo } from "../integration/state-getters.js";
import "../state/reducers.js";
import "../state/actions.js";
import "../state/utils.js";
import "../store/storage/memory-storage.js";
import "mitt";
import "../store/storage/universal-memory-storage.js";
import "@reduxjs/toolkit";
import { initializeHost } from "../store/state/initialization.js";
import "../store/state/host.js";
import "../store/state/modal.js";
import "../config/source-ids.js";
import { Loader } from "./Loader.js";
import { getMfServer, getFlagContext } from "./utils.js";
const AccountPortalAstroClient = createReactClient({
  mfId: "ap/v1",
  server: getMfServer("/ap/mf"),
  ErrorView() {
    return /* @__PURE__ */ React.createElement("div", null, "Failed to load Account Portal");
  },
  onError(error) {
    closeAccountPortal();
    instana("reportError", error, {
      meta: {
        errorId: "AccountPortalMF_Error",
        mfId: "ap/v1"
      }
    });
  }
});
const LoaderView = (props) => {
  const { isMobile } = useDevice();
  const { isModalVisible } = useRuntimeInfo();
  const isInlineView = isInlinePreset(props.preset);
  return isInlineView ? /* @__PURE__ */ React.createElement(Loader, { showLogo: true }) : /* @__PURE__ */ React.createElement(
    GlModal,
    {
      id: "client-account-portal",
      title: "Account Portal Client Modal",
      showTitle: false,
      closeButtonLabel: "",
      disablePortal: true,
      size: isMobile ? "full-mobile" : "small",
      open: isModalVisible,
      className: props.className,
      onClose: closeAccountPortal
    },
    /* @__PURE__ */ React.createElement(Loader, { showLogo: true })
  );
};
const AccountPortalClient = (props) => {
  useMemo(() => {
    initializeHost({
      context: props.context
    });
  }, []);
  const mfId = config.mfId;
  const flags = useFeatureFlags();
  const isFlagsReady = Object.keys(flags).length > 0;
  const mfServer$1 = mfServer.evaluateWithContext(props.context);
  const mfProps = {
    mfId,
    mfServer: mfServer$1,
    clientVersion: version,
    ...props
  };
  const { isModalVisible, preset: runtimePreset } = useRuntimeInfo();
  const preset = props.preset === "modal" || !props.preset ? runtimePreset : props.preset;
  const isInlineView = isInlinePreset(props.preset);
  const { isAuthProvider, view: presetView, formView, registrationFlow } = getPreset(props.preset);
  const isModalClient = presetView === "modal";
  useEffect(() => {
    updateRuntimeInfo({
      mfId,
      isAuthProvider,
      isAccountPortalEnabled: true,
      preset: props.preset,
      touchpoint: props.touchpoint,
      pageContext: props.pageContext,
      clientVersion: version,
      propSourceId: props.sourceId,
      hasModalClient: isModalClient || getRuntimeInfo().hasModalClient
    });
  }, []);
  useEffect(() => {
    saveInvitationCodeValue();
  }, []);
  const onError = (error) => {
    closeAccountPortal();
    instana("reportError", error, {
      meta: {
        errorId: "AccountPortalMF_Error",
        mfId
      }
    });
  };
  if (!isInlineView && !isModalVisible) {
    return null;
  }
  const isSubscriptionFlow = formView === FormView.OneStep && registrationFlow === RegistrationFlow.LightAccount;
  if (isModalViewForbiddenPath() && !isInlineView) {
    return null;
  }
  if (flags.ACCOUNT_PORTAL_AUTHN && !isSubscriptionFlow) {
    return /* @__PURE__ */ React.createElement(
      AccountPortalAuthN,
      {
        ...props,
        preset
      }
    );
  }
  if (flags.ACCOUNT_PORTAL_LEGACY) {
    return /* @__PURE__ */ React.createElement(
      MicrofrontendClient,
      {
        mfId,
        mfServer: mfServer$1,
        mfProps,
        mfConfig: config,
        onError,
        ...props
      },
      /* @__PURE__ */ React.createElement(LoaderView, { ...props })
    );
  }
  return /* @__PURE__ */ React.createElement(
    AccountPortalAstroClient,
    {
      env: props.context.env,
      locale: props.context.locale,
      render: isFlagsReady,
      styleDependencies: props.loadStyleDependencies,
      ...props,
      preset
    },
    /* @__PURE__ */ React.createElement(LoaderView, { ...props })
  );
};
const AccountPortal = (props) => {
  return /* @__PURE__ */ React.createElement(FeatureFlagsProvider, { context: getFlagContext(props.context), project: "account-acquisition" }, /* @__PURE__ */ React.createElement(AccountPortalClient, { ...props }));
};
export {
  AccountPortal
};
//# sourceMappingURL=AccountPortal.js.map
